import { notify } from "@kyvg/vue3-notification";
import http from "@/utils/axios";
import { apiPaths } from "@/dictionaries/api/paths";

export default {
  namespaced: true,
  state: {
    invoices: [],
    pagination: {
      currentPage: 1,
      total: 1,
    },

    totalPriceRange: [1, 10000],
  },
  getters: {
    getInvoices: (state) => state.invoices,
    getPagination: (state) => state.pagination,
    getStats: (state) => state.stats,
    getTotalPriceRange: (state) => state.totalPriceRange,
  },
  mutations: {
    setInvoices(state, invoices) {
      state.invoices = invoices.data;
      state.pagination.currentPage = invoices.meta.current_page;
      state.pagination.total = invoices.meta.last_page;
    },
    setCurrentPage(state, currentPage) {
      state.pagination.currentPage = currentPage;
    },
    setStats(state, stats) {
      Object.assign(state.stats, stats);
    },
    setTotalPriceRange(state, totalPriceRange) {
      state.totalPriceRange = totalPriceRange;
    },
    clearInvoices(state) {
      state.invoices = [];
    },
  },
  actions: {
    async fetchInvoices({ commit, state }, { filters }) {
      await http
        .get(apiPaths.admin.invoices.createdInvoices, {
          params: {
            page: state.pagination.currentPage,
            ...filters,
          },
        })
        .then(({ data }) => {
          commit("setInvoices", data);
        })
        .catch(({ response }) => {
          if (response && response.status === 403)
            notify({
              type: "danger",
              text: "messages.permission.failure",
              duration: 5000,
            });
        });
    },
  },
};
